// Init options shared by every i18next instance (runtime, test harness,
// service-worker message getter). The catalogues in ./locales only render
// correctly under these options plus i18next defaults they rely on. Spread
// this object and do NOT override:
//
// - `interpolation.escapeValue: false` — React escapes at render time
//   (matches the channels app); the copy was never HTML-escaped.
// - `interpolation.format` / custom `list` formatter — `{{x, list}}` keys use
//   the built-in Intl.ListFormat formatter.
// - Plural resolution defaults — the catalogues carry per-locale `_zero`
//   variants (picked via i18next's `count === 0` special case) and collapse
//   identical plural branches per locale, relying on the missing-plural-suffix
//   -> base-key fallback for shared call sites.
// - `$t()` nesting (`nestingPrefix` etc.) — shared strings and multi-variable
//   messages reference other keys through nesting with count/context options.
export const baseInitOptions = {
  interpolation: {
    escapeValue: false
  }
};